export default __webpack_public_path__ + "static/media/iPadSS1.231a7d70.png";